import { Trans, useTranslation } from 'react-i18next'

import { LanguageSelector } from 'src/components/language-selector/LanguageSelector'
import { CONTACT } from 'src/constants/contact'
import { NS } from 'src/constants/i18n'

const Link = (props: { target?: string; href?: string }) => (
  <a rel="noopener noreferrer" target="_blank" className="underline" {...props} />
)

const currentYear = new Date().getFullYear()

export const TermsOfService = () => {
  const { t } = useTranslation(NS.TRACKING)

  return (
    <div className="flex flex-col gap-8" data-testid="terms-of-service-section">
      <LanguageSelector />

      <p className="text-center text-wrap text-muted-foreground">
        <Trans
          i18nKey={`${NS.TRACKING}:terms.description`}
          values={{ contactEmail: CONTACT.SUPPORT_EMAIL }}
          components={{
            contactEmail: <Link href={`mailto:${CONTACT.SUPPORT_EMAIL}`} />,
            termsOfServiceLink: <Link href={t('terms.links.termsOfService')} />,
            requestTermsLink: <Link href={t('terms.links.requestTerms')} />,
            privacyNoticeLink: <Link href={t('terms.links.privacyNotice')} />,
            californiaPrivacyNotice: <Link href={t('terms.links.californiaPrivacyNotice')} />,
          }}
        />
      </p>

      <p className="text-center text-muted-foreground">
        {t('terms.copyright', { year: currentYear })}
      </p>
    </div>
  )
}
